import { createSlice } from '@reduxjs/toolkit'
import posthog from 'posthog-js'

// Slice
const slice = createSlice({
  name: 'user',
  initialState: {
    user: null
  },
  reducers: {
    loginSuccess: (state, action) => {
      state.user = action.payload
    },
    logoutSuccess: (state, action) => {
      state.user = null
    }
  }
})

export default slice.reducer

// Actions
const { loginSuccess, logoutSuccess } = slice.actions

export const login =
  ({ userId, userEmail, firstName, lastName, imageUrl, createdAt }) =>
  async dispatch => {
    try {
      localStorage.setItem('username', userId)
      // Connect user to posthog with Clerk user properties
      posthog.identify(userId, {
        email: userEmail,
        first_name: firstName,
        last_name: lastName,
        name: [firstName, lastName].filter(Boolean).join(' ') || undefined,
        avatar: imageUrl,
        created_at: createdAt
      })
      dispatch(
        loginSuccess({
          username: userId
        })
      )
    } catch (e) {
      return console.error(e.message)
    }
  }

export const logout = () => async dispatch => {
  try {
    localStorage.removeItem('username')
    localStorage.removeItem('token')
    posthog.reset()
    return dispatch(logoutSuccess())
  } catch (e) {
    return console.error(e.message)
  }
}
